import { jsx as r } from "react/jsx-runtime";
import { cn as d } from "../../lib/utils.js";
function i({
  className: a,
  size: t = "default",
  ...e
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card",
      "data-size": t,
      className: d(
        "group/card flex flex-col gap-4 overflow-hidden rounded-xl bg-card py-4 text-sm text-card-foreground ring-1 ring-foreground/10 has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:gap-3 data-[size=sm]:py-3 data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl",
        a
      ),
      ...e
    }
  );
}
function n({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-header",
      className: d(
        "group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-4 group-data-[size=sm]/card:px-3 has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-4 group-data-[size=sm]/card:[.border-b]:pb-3",
        a
      ),
      ...t
    }
  );
}
function c({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-title",
      className: d(
        "font-heading text-base leading-snug font-medium group-data-[size=sm]/card:text-sm",
        a
      ),
      ...t
    }
  );
}
function l({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-description",
      className: d("text-sm text-muted-foreground", a),
      ...t
    }
  );
}
function u({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-action",
      className: d(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        a
      ),
      ...t
    }
  );
}
function m({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-content",
      className: d("px-4 group-data-[size=sm]/card:px-3", a),
      ...t
    }
  );
}
function p({ className: a, ...t }) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-slot": "card-footer",
      className: d(
        "flex items-center rounded-b-xl border-t bg-muted/50 p-4 group-data-[size=sm]/card:p-3",
        a
      ),
      ...t
    }
  );
}
export {
  i as Card,
  u as CardAction,
  m as CardContent,
  l as CardDescription,
  p as CardFooter,
  n as CardHeader,
  c as CardTitle
};
//# sourceMappingURL=card.js.map
